import { axiosGet, axiosPost } from "../react_axios/Axios"
import { getFillListUrl, platform, GET_FILL_LIST_ACTION_TYPE, headers } from "../utils/constants"

export const fill_action = (actionID, UserID, keyword, keyvalue) => async (dispatch) => {

    try {
        const mapdata = {
            ActionID: actionID,
            UserID:  UserID,
            keyword: keyword,
            keyvalue: keyvalue,
        }
        const res = await axiosGet(getFillListUrl, mapdata);
        // console.log(mapdata)
        dispatch({
            type: GET_FILL_LIST_ACTION_TYPE,
            payload: res,
        });
        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }
};

